var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.828 10.778H20V12.778H7.828L13.192 18.142L11.778 19.556L4 11.778L11.778 4L13.192 5.414L7.828 10.778Z",
    fill: "#0074BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollapse);
export default __webpack_public_path__ + "static/media/icon_collapse.5a5cf86b631026a945b97063b8bc4ade.svg";
export { ForwardRef as ReactComponent };